import gql from 'graphql-tag'

export const GET_WORKER_STREAM_INFO = gql`
  query {
    streamInfo @client {
      streamId,
      isAuthenticated
    }
  }
`

export const SET_WORKER_STREAM_INFO = gql`
  mutation setWorkerStreamInfo($streamInfo: WorkerStreamInfo) {
    setWorkerStreamInfo(streamInfo: $streamInfo) @client
  }
`

export const SET_AWAIT_SERVER_RESPONSE = gql`
  mutation setAwaitServerResponse($isPending: Boolean) {
    setAwaitServerResponse(isPending: $isPending) @client
  }
`

export const GET_IS_REQUEST_PENDING = gql`
  query {
    isPending @client
  }
`
